module.exports = __webpack_public_path__ + "img/C04WarWagonS_ua.0d61cc20.webp";